/* unplugin-vue-components disabled */import { render } from "./portal-legal-renewal.vue?vue&type=template&id=ac82f8ac"
import script from "./portal-legal-renewal.vue?vue&type=script&lang=js"
export * from "./portal-legal-renewal.vue?vue&type=script&lang=js"

import "./portal-legal-renewal.vue?vue&type=style&index=0&id=ac82f8ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__